export default "__VITE_ASSET__CbymDS$4__"